export function convertHexToRGBA(hex: string, alpha: number = 1): string {
  const cleanHex = hex.replace('#', '');

  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  
  const validAlpha = Math.min(Math.max(alpha, 0), 1);
  
  return `rgba(${r}, ${g}, ${b}, ${validAlpha})`;
}
